(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.buttons
  (:require
   [common.localization :as loc]
   [common.localization :as loc]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.ui.page.lp-report-editor.common.modal.notification-email-modal :as email-modal]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.event :as event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.event :as data-gathering-event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.feeder-report.event :as feeder-event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.fund-report.event :as report-event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn fund-wip-buttons
  ([on-submit label-kw]
   (fund-wip-buttons on-submit label-kw false))
  ([on-submit label-kw feeder-fund?]
   (let [completed-amount @(rf/subscribe [::sub/rich-text-completed-amount])
         feeder-completed-amount @(rf/subscribe [::sub/feeder-rich-text-completed-amount])
         show-amount? (tenant-customizations/capman?)]
     [button/primary-solid
      {:on-click #(rf/dispatch on-submit)}
      (str (loc/tr label-kw) (when (and (= label-kw :submit-for-review-text)
                                                 show-amount?)
                                        (if feeder-fund?
                                          feeder-completed-amount
                                          completed-amount)))])))

(defn fund-withdraw-button
  [on-reject reject-lbl-kw]
  [:<>
   [button/secondary-hollow
    {:on-click #(rf/dispatch on-reject)}
    (loc/tr reject-lbl-kw)]])

(defn fund-pending-buttons
  [on-reject reject-lbl-kw on-approve approve-lbl-kw]
  [:<>
   [:div
    {:class-name "flex gap-3"}
    [button/danger-solid
     {:on-click #(rf/dispatch on-reject)}
     (loc/tr reject-lbl-kw)]
    [button/primary-solid
     {:on-click #(rf/dispatch on-approve)}
     (loc/tr approve-lbl-kw)]]])

(defn fund-approved-buttons
  [on-reject reject-lbl-kw]
  [button/warning-solid
   {:on-click #(rf/dispatch on-reject)}
   (loc/tr reject-lbl-kw)])


(defn reject-email-modal
  [recipients on-reject-confirmed]
  (when-let [report-id @(rf/subscribe [::sub/fund-text-rejected?])]
    [email-modal/view
     {:on-hide!       (fn []
                        (rf/dispatch [::event/clear-notification report-id]))
      :recipients     recipients
      :header         (loc/tr :reject-text)
      :on-skip-email! (fn [_]
                        (rf/dispatch (vec (concat on-reject-confirmed [[] nil])))
                        (rf/dispatch [::event/clear-notification report-id]))
      :on-submit!     (fn [filtered-recipients message]
                        (rf/dispatch (vec (concat on-reject-confirmed
                                                  [filtered-recipients message])))
                        (rf/dispatch [::event/clear-notification report-id]))}]))

(defn submit-email-modal
  [recipients on-submit-confirmed report-rich-content-list feeder?]
  (let [on-complete-richtext! (if feeder?
                                (fn [report-id edit-path edit-value complete-path complete-status]
                                  (rf/dispatch [::feeder-event/save-fund-report-text report-id
                                                edit-path edit-value
                                                complete-path complete-status]))
                                (fn [report-id edit-path edit-value complete-path complete-status]
                                  (rf/dispatch [::report-event/save-fund-report-text report-id
                                                edit-path edit-value
                                                complete-path complete-status])))
        on-complete-all! (fn [report-id feeder?]
                           (rf/dispatch [::data-gathering-event/complete-remaining-texts report-id feeder?]))]
    (when-let [report-id @(rf/subscribe [::sub/fund-text-submitted?])]
      [email-modal/view
       {:on-hide!       (fn []
                          (rf/dispatch [::event/clear-notification report-id]))
        :on-complete-richtext! on-complete-richtext!
        :on-complete-all! on-complete-all!
        :feeder? feeder?
        :recipients     recipients
        :report-rich-content-list report-rich-content-list
        :header         (loc/tr :submit-for-review-text)
        :on-skip-email! (fn [_]
                          (rf/dispatch (vec (concat on-submit-confirmed [[] nil])))
                          (rf/dispatch [::event/clear-notification report-id]))
        :on-submit!     (fn [filtered-recipients message]
                          (rf/dispatch (vec (concat on-submit-confirmed
                                                    [filtered-recipients message])))
                          (rf/dispatch [::event/clear-notification report-id]))}])))
(defn fund-text-buttons
  [feeder? report submit-recipients report-rich-content-list on-submit on-submit-confirmed reject-recipients on-reject
   on-reject-confirmed on-approve can-edit? can-approve?]
  [:div
   [reject-email-modal reject-recipients on-reject-confirmed]
   [submit-email-modal submit-recipients on-submit-confirmed report-rich-content-list feeder?]
   (case (:lp-report/text-status report)
     :lp-report.publishing-status/wip
     (when can-edit?
       [fund-wip-buttons on-submit :submit-for-review-text feeder?])

     :lp-report.publishing-status/pending-approval
     (if can-approve?
       [fund-pending-buttons
        on-reject :reject-text
        on-approve :approve-text]
       [fund-withdraw-button
        on-reject :withdraw-submission-text])

     :lp-report.publishing-status/approved
     (when can-approve?
       [fund-approved-buttons on-reject :reject-text])
     (when can-edit?
       [fund-wip-buttons on-submit :submit-for-review-text feeder?]))])

(defn reject-data-email-modal
  [recipients on-reject-confirmed]
  (when-let [report-id @(rf/subscribe [::sub/fund-data-rejected?])]
    [email-modal/view
     {:on-hide!       (fn []
                        (rf/dispatch [::event/clear-notification report-id]))
      :recipients     recipients
      :header         (loc/tr :reject-data)
      :on-skip-email! (fn [_]
                        (rf/dispatch (vec (concat on-reject-confirmed [[] nil])))
                        (rf/dispatch [::event/clear-notification report-id]))
      :on-submit!     (fn [filtered-recipients message]
                        (rf/dispatch (vec (concat on-reject-confirmed
                                                  [filtered-recipients message])))
                        (rf/dispatch [::event/clear-notification report-id]))}]))

(defn submit-data-email-modal
  [recipients on-submit-confirmed]
  (when-let [report-id @(rf/subscribe [::sub/fund-data-submitted?])]
    [email-modal/view
     {:on-hide!       (fn []
                        (rf/dispatch [::event/clear-notification report-id]))
      :recipients     recipients
      :header         (loc/tr :submit-for-review-data)
      :on-skip-email! (fn [_]
                        (rf/dispatch (vec (concat on-submit-confirmed [[] nil])))
                        (rf/dispatch [::event/clear-notification report-id]))
      :on-submit!     (fn [filtered-recipients message]
                        (rf/dispatch (vec (concat on-submit-confirmed
                                                  [filtered-recipients message])))
                        (rf/dispatch [::event/clear-notification report-id]))}]))
(defn fund-data-buttons
  [report submit-recipients on-submit on-submit-confirmed reject-recipients on-reject
   on-reject-confirmed on-approve can-edit? can-approve?]
  [:div.flex.gap-3
   [reject-data-email-modal reject-recipients on-reject-confirmed]
   [submit-data-email-modal submit-recipients on-submit-confirmed]
   (case (:lp-report/data-status report)
     :lp-report.publishing-status/wip
     (when can-edit?
       [fund-wip-buttons on-submit :submit-for-review-data])

     :lp-report.publishing-status/pending-approval
     (if can-approve?
       [fund-pending-buttons
        on-reject :reject-data
        on-approve :approve-data]
       [fund-withdraw-button
        on-reject :withdraw-submission-data])

     :lp-report.publishing-status/approved
     (when can-approve?
       [fund-approved-buttons on-reject :reject-data])
     (when can-edit?
       [fund-wip-buttons on-submit :submit-for-review-data]))])
